export const notificationTemplatesConfig = {
  /* ------------------------------- GET ----------------------------------- */

  getMailTemplates: {
    key: "getMailTemplates",
    url: "/api/v1/notification/email-templates",
    method: "GET",
    options: {
      staleTime: 60_000, // 1 min
      gcTime: 5 * 60 * 1000, // 5 min
      refetchOnWindowFocus: false,
      keepPreviousData: true,
    },
  },

  getEmailTemplateById: {
    key: "getEmailTemplateById",
    url: (data) => `/api/v1/notification/email-templates/${data.id}`,
    method: "GET",
    options: {
      staleTime: 60_000, // 1 min
      gcTime: 5 * 60 * 1000, // 5 min
      refetchOnWindowFocus: false,
    },
  },

  /* ------------------------------- POST ----------------------------------- */

  createEmailTemplate: {
    key: "createEmailTemplate",
    url: "/api/v1/notification/email-templates",
    method: "POST",
    options: {
      invalidateKeys: ["getMailTemplates"],
    },
  },

  /* ------------------------------- PUT ----------------------------------- */

  updateEmailTemplate: {
    key: "updateEmailTemplate",
    url: "/api/v1/notification/email-templates",
    method: "PUT",
    options: {
      invalidateKeys: ["getMailTemplates", "getEmailTemplateById"],
    },
  },

  /* ------------------------------- DELETE ----------------------------------- */

  deleteEmailTemplate: {
    key: "deleteEmailTemplate",
    url: (data) => `/api/v1/notification/email-templates/${data.id}`,
    method: "DELETE",
    options: {
      invalidateKeys: ["getEmailTemplates"],
    },
  },

  /* ------------------------------- NOTIFICATION SETTINGS ----------------------------------- */

  getNotificationSettings: {
    key: "getNotificationSettings",
    url: "/api/v1/notification/settings",
    method: "GET",
    options: {
      staleTime: 60_000, // 1 min
      gcTime: 5 * 60 * 1000, // 5 min
      refetchOnWindowFocus: false,
      keepPreviousData: true,
    },
  },

  updateNotificationSettings: {
    key: "updateNotificationSettings",
    url: "/api/v1/notification/settings",
    method: "PUT",
    options: {
      invalidateKeys: ["getNotificationSettings"],
    },
  },
};
